import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MultpleCard from "../components/Multple-card";
import Faq from "../components/Faq";
import ContactForm from "../components/contact-form";
import QuotePopup from "../components/Quote-popup";
import { initializeAppScripts } from "../main";
import approachIcon from "../images/approach.png";
import valuesIcon from "../images/values.png";
import supportIcon from "../images/Support.png";
import testingIcon from "../images/Testing.png";
import aboutImage from "../images/comp/About.webp";

const AboutPage = () => {
  useEffect(() => {
    initializeAppScripts();
  }, []);

  const cardsData = [
    {
      title: "Our Approach",
      description:
        "We always listen our client very carefully and make a proper plan for project as per client ideas.",
      icon: approachIcon,
    },
    {
      title: "Our Values",
      description:
        "We always value our relationship with clients, we value each project whether its small or large.",
      icon: valuesIcon,
    },
    {
      title: "Our Support",
      description:
        "We provide long term support for any project, We always available for priorty support and assistance.",
      icon: supportIcon,
    },
    {
      title: "Our Resources",
      description:
        "We have skilled resources, who is well experienced in their relative technologies and required skills.",
      icon: testingIcon,
    },
  ];

  return (
    <>
      <Header />

      <section className="hero-section-about d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 hero-content text-center">
              <span className="portfolio-hero-subtitle">About Our Company</span>

              <div className="hedding process-underline-flex justify-content-center">
                <div className="process-underline"></div>
                <div className="process-underline"></div>
              </div>

              <p className="about-title mb-0 px-0 py-0">
                At Hope Web Solutions, we believe that a strong online presence
                is the key to unlocking your business’s full potential. Founded
                with a passion for creativity and technology, we specialize in
                delivering innovative, customized web solutions that help
                businesses of all sizes grow and thrive in the digital world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="planning-section">
        <div className="container">
          <div className="process-grid mt-0">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <section className="planning-section services-section">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 col-md-12 position-relative text-center">
              <h2 className="title">Highlights of Our Success Story</h2>
              <p className="sub-title text-black mb-0 mt-2">
                Here’s a glimpse of what we’ve accomplished through dedication,
                innovation, and teamwork. Don’t just take our word for it —
                explore our work and see the results for yourself.
              </p>
            </div>
          </div>

          <div className="process-grid">
            <div className="process-card service-card success">
              <div className="success-number">700+</div>
              <div className="process-desc fw-semibold">Projects Delivered</div>
            </div>
            <div className="process-card service-card success bg-color-success">
              <div className="success-number">55+</div>
              <div className="process-desce fw-semibold">Professionals</div>
            </div>
            <div className="process-card service-card success">
              <div className="success-number">150+</div>
              <div className="process-desc fw-semibold">Client Retention</div>
            </div>
            <div className="process-card service-card success bg-color-success">
              <div className="success-number">16+</div>
              <div className="process-desc fw-semibold">Year of Experience</div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0 position-relative">
              <img
                src={aboutImage}
                alt="Team"
                className="img-fluid rounded about-img"
              />
            </div>
            <div className="col-lg-6">
              <h2 className="title">
                We Can Clients With The
                <span className="about-label">About Solution.</span>
              </h2>
              <p className="sub-title-about">
                Monotonectally repurpose maintainable infrastruct whereas
                solutek in fermentum quis tempo sapien maximus design.
              </p>
              <p className="sub-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                    fill="#FC7600"
                  />
                </svg>
                Best IT Solutions & Service
              </p>
              <p className="sub-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                    fill="#FC7600"
                  />
                </svg>
                24 Hour's Customer Service
              </p>
              <p className="sub-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                    fill="#FC7600"
                  />
                </svg>
                Top-Notch Web & App Development Services
              </p>
              <p className="sub-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                    fill="#FC7600"
                  />
                </svg>
                Highly Skilled Team With Excellent Communication
              </p>
              <p className="sub-title">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.6395 8.88247C16.1202 8.39438 16.1202 7.60172 15.6395 7.11363L9.48636 0.866068C9.00565 0.377977 8.22497 0.377977 7.74426 0.866068C7.26355 1.35416 7.26355 2.14682 7.74426 2.63491L13.0282 8L7.74811 13.3651C7.2674 13.8532 7.2674 14.6458 7.74811 15.1339C8.22882 15.622 9.00949 15.622 9.49021 15.1339L15.6433 8.88637L15.6395 8.88247ZM2.10263 15.13L8.25574 8.88247C8.73645 8.39438 8.73645 7.60172 8.25574 7.11363L2.10263 0.866068C1.62192 0.377977 0.841245 0.377977 0.360534 0.866068C-0.120178 1.35416 -0.120178 2.14682 0.360534 2.63491L5.64451 8L0.364379 13.3651C-0.116332 13.8532 -0.116332 14.6458 0.364379 15.1339C0.845091 15.622 1.62577 15.622 2.10648 15.1339L2.10263 15.13Z"
                    fill="#FC7600"
                  />
                </svg>
                Delivery As Per Requirements & Client Ideas
              </p>

              <a href="#" className="btn btn-orange mt-1">
                Contact now
              </a>
            </div>
          </div>
        </div>
      </section>
      <Faq />
      <QuotePopup />
      <Footer />
    </>
  );
};

export default AboutPage;
